import { Component } from '@angular/core';

@Component({
  selector: 'app-cp-00-17-10-12',
  standalone: true,
  imports: [],
  templateUrl: './cp-00-17-10-12.component.html',
  styleUrl: './cp-00-17-10-12.component.scss'
})
export class Cp00171012Component {

}
